import { Clear } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useClearButtonStyles from './styles';
import { ClearButtonProps } from './types';

const ClearButton: React.FunctionComponent<ClearButtonProps> = (props) => {
  const { t } = useTranslation('common');
  const classes = useClearButtonStyles(props);
  const renderClearButton = () => {
    return (
      <Tooltip title={t('clear')}>
        <IconButton size='small' className={classes.clearButton} {...props}>
          <Clear fontSize='small' />
        </IconButton>
      </Tooltip>
    );
  };

  return renderClearButton();
};

export default ClearButton;
